import { render } from "./DayforceIntegration.vue?vue&type=template&id=1f87969b"
import script from "./DayforceIntegration.vue?vue&type=script&lang=js"
export * from "./DayforceIntegration.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__